import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { useAccount } from "../../../contexts/AccountContext";

const DropboxCallback: React.FC = () => {
  const { account } = useAccount();

  const params = new URLSearchParams(window.location.hash.substring(1));
  const accessToken = params.get("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken && account?.id) {
      let isMounted = true;
      const accountId = account.id;

      const getUserInfo = async () => {
        try {
          const db = getFirestore();
          await setDoc(
            doc(db, "accounts", accountId, "integrations", "dropbox"),
            {
              accessToken,
            },
            { merge: true },
          );

          if (isMounted) {
            navigate("/settings/integrations");
          }
        } catch (error) {
          if (isMounted) {
            console.error("Error syncing Dropbox:", error);
            alert("Failed to sync Dropbox. Please try again later.");
          }
        }
      };

      getUserInfo();

      return () => {
        isMounted = false;
      };
    }
  }, [accessToken, account, navigate]);

  return <div>Authorizing Dropbox...</div>;
};

export default DropboxCallback;
